export default __webpack_public_path__ + "app/assets/images/dashboard/img-mobile-ebef283d9bc9c388c1bed6dafc232f56.png";